import type { ChangeEvent, FC, HTMLInputTypeAttribute } from 'react';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import { TextField } from '@mui/material';
import type { ActionProps } from '../../types';

type SubActionValueProps = Pick<ActionProps, 'indexAction' | 'indexTask' | 'indexVariant'> & {
  type?: HTMLInputTypeAttribute;
  disabled?: boolean;
};
export const SubActionValue: FC<SubActionValueProps> = observer(
  ({ indexAction, indexTask, indexVariant, disabled, type = 'text' }) => {
    const { isRead } = useRulePageMode();
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeMetric = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        tasksFormStore.setSubActionField({
          indexTask,
          indexAction,
          indexVariant,
          field: 'value',
          value: e.target.value,
        });
      },
      [tasksFormStore, indexTask, indexVariant, indexAction]
    );

    const storedValue = tasksFormStore.getSubActionValues({ indexTask, indexAction, indexVariant }).value;

    return (
      <TextField
        value={storedValue ?? ''}
        onChange={handleChangeMetric}
        sx={{
          '&.MuiTextField-root': { width: '100%' },
          '& .MuiInputBase-input': { borderRadius: 0 },
          '& .MuiOutlinedInput-root': { maxHeight: 36, minHeight: 36, borderRadius: 0, px: 2 },
          '& fieldset': { border: 'none', top: 0 },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            display: 'none',
          },
        }}
        InputProps={{ inputProps: { min: 0, style: { padding: 0, textAlign: 'left' } } }}
        type={type}
        placeholder={'Value'}
        disabled={disabled ?? isRead}
      />
    );
  }
);

export default SubActionValue;
